import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ProductProvider } from './contexts/ProductContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import SubmitProduct from './pages/SubmitProduct';
export function App() {
  return <ProductProvider data-id="element-0">
      <Helmet data-id="element-1">
        <title data-id="element-2">FayMarket</title>
      </Helmet>
      <Router data-id="element-3">
        <Layout data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/products" element={<Products data-id="element-9" />} data-id="element-8" />
            <Route path="/products/:id" element={<ProductDetail data-id="element-11" />} data-id="element-10" />
            <Route path="/submit-product" element={<SubmitProduct data-id="element-13" />} data-id="element-12" />
          </Routes>
        </Layout>
      </Router>
    </ProductProvider>;
}